import { RoutersType } from "../type/routes";
import SCRS080001 from "../pages/SCRS080001";

/**
 * アプリケーションのルートオブジェクトの配列です。
 * @typedef {Object} RoutersType
 * @property {string} name - ルートの名前。
 * @property {string} path - ルートのパス。
 * @property {React.ComponentType} component - ルートにレンダリングするコンポーネント。
 */
const routes: RoutersType[] = [
  {
    name: "掛金対象法人・職員情報照会",
    path: "/SCRS080001",
    component: SCRS080001,
    meta: {
      title: "掛金対象法人・職員情報照会",
    },
  },
];

export { routes };
